<template>
  <div>
    <el-dialog
      :visible.sync="localShowDetailExportDialog"
      center
      :close-on-click-modal="false"
      @close="closeDetailExportDialog"
      custom-class="dialog_1000 limit_height new-dialog"
      :append-to-body="true"
      title="Export Fields"
    >
      <div class="dialog_cont">
        <div class="flex list_content_box">
          <div class="left">
            <div class="input_filter">
              <i class="iconfont icon-search icon"></i>
              <el-input
                autocomplete="off"
                placeholder="Finde a filter…"
                v-model="filterText"
              >
              </el-input>
            </div>
            <div class="menu_box">
              <div class="frist_menu_box">
                <el-collapse v-model="activeFrist">
                  <el-collapse-item
                    :name="item.id"
                    :class="{ on: item.id == activeItemId }"
                    v-for="item in filteredFilterList"
                    :key="item.id"
                  >
                    <div slot="title">
                      <overflow-tooltip :tip="item.name" />
                    </div>
                    <ul class="frist_sub_ul">
                      <li
                        v-for="subItem in item.children"
                        :key="subItem.id"
                        class="frist_sub_li"
                        :class="{
                          has_sec:
                            detailCompanyOptions.length > 0 &&
                            subItem.id === activeSubItemId,
                        }"
                      >
                        <el-checkbox
                          :indeterminate="indeterminateSubItems[subItem.id]"
                          v-model="subItem.isChecked"
                          @change="handleSubItemCheck(subItem)"
                        >
                          <overflow-tooltip :tip="subItem.name" />
                        </el-checkbox>
                        <i class="iconfont icon-jiantouyou icon_right"></i>
                      </li>
                    </ul>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="sec_menu_box">
                <div v-show="detailCompanyOptions.length > 0">
                  <el-checkbox
                    disabled
                    v-model="companyOption.isChecked"
                    v-for="companyOption in detailCompanyOptions"
                    :label="companyOption.id"
                    :key="companyOption.id"
                  >
                    <OverflowTooltip :tip="companyOption.name" />
                  </el-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="top_select_title">
              Selected Columns ({{ selectedCount }})
            </div>
            <div class="sel_ul_Col_box">
              <ul v-for="fristSelItem in filterList" :key="fristSelItem.id">
                <li
                  class="selCol_item"
                  v-for="list2 in fristSelItem.children.filter(
                    (ops) => ops.isChecked,
                  )"
                  :key="list2.id"
                >
                  <div class="sel_frist_name">
                    <div
                      class="sel_frist_name_box"
                      @click="toggleSecMenu(list2.id)"
                      :class="{ open: openSecMenus[list2.id] }"
                    >
                      <OverflowTooltip :tip="list2.name" />
                      <i
                        class="iconfont icon-jiantouxia sel_col_icon_right"
                        :class="{ rotate: openSecMenus[list2.id] }"
                      ></i>
                    </div>
                    <i
                      class="iconfont icon-cuowu icon_cuowu"
                      @click="delFristChosen(list2)"
                    ></i>
                  </div>

                  <div
                    class="sel_sec_name_box"
                    ref="secMenuBox"
                    :class="{ show: openSecMenus[list2.id] }"
                  >
                    <div
                      v-for="item in list2.children.filter(
                        (ops) => ops.isChecked,
                      )"
                      :key="item.id"
                      class="sel_sec_name"
                    >
                      <OverflowTooltip :tip="item.name" />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog_footer">
        <el-button
          type="text"
          class="btn_reset_txt"
          :disabled="selectedColumns.length == 0"
          @click="resetDefaultView"
          >Reset Default View</el-button
        >
        <el-button
          class="btn_export btnbox"
          :disabled="selectedColumns.length == 0"
          @click="onApplyChanges"
          >Apply Changes</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="localConfirmExportDialog"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @before-close="closeConExportDialog"
      custom-class="dialog_1000 new-dialog export_dialog"
      :append-to-body="true"
      :title="title"
    >
      <div>
        <div class="dialog_cont">
          <div class="flie_content_box">
            <div class="fileTips">
              How many results would you like to export form this search? You
              may also fefine your search by including additional filter(s).
            </div>
            <div class="file_group">
              <label class="file_label">File Name:</label>
              <el-input
                v-model="localExportFileName"
                placeholder="Please enter a file name"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="flex_center">
        <el-button class="btn_cancel btnbox" @click="cancelExport"
          >Cancel</el-button
        >
        <el-button class="btn_export btnbox" @click.stop="backExport"
          >Back</el-button
        >
        <el-button class="btn_export btnbox" @click="exportCompanyDetailData"
          >Export</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getComDetExpMenuList,
  exportCompanyDetail,
  getComDetExpThreeMenuList,
} from "@/api/companyApi";
export default {
  name: "detailExportDialog",
  props: {
    showDetailExportDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filterList: [],
      localShowDetailExportDialog: this.showDetailExportDialog,
      filterText: "",
      detailCompanyOptions: [],
      localConfirmExportDialog: false,
      localExportFileName: "Company" + this.getCurrentDate(),
      activeItemId: null,
      title: "",
      activeFrist: [],
      indeterminateSubItems: {},
      activeSubItemId: null,
      openSecMenus: {},
      threeMenuList: [],
    };
  },
  computed: {
    filteredFilterList() {
      if (!this.filterText) {
        return this.filterList;
      }

      const filterText = this.filterText.toLowerCase();
      return this.filterList.filter((item) =>
        item.name.toLowerCase().includes(filterText),
      );
    },
    selectedColumns() {
      // 收集所有选中的列
      const selected = [];
      this.filterList.forEach((item) => {
        item.children.forEach((subItem) => {
          if (subItem.isChecked) {
            selected.push(subItem);
          }
        });
      });
      return selected;
    },
    selectedCount() {
      return this.selectedColumns.length;
    },
  },
  watch: {
    showDetailExportDialog: {
      handler(newVal) {
        this.localShowDetailExportDialog = newVal;
      },
      immediate: true,
    },
    localShowDetailExportDialog(newVal) {
      this.$emit("update:showDetailExportDialog", newVal);
    },
  },
  mounted() {
    this.getExportMenuList();
  },
  methods: {
    // 获取当前日期
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}${month}${day}`;
    },
    // 关闭一级弹窗
    closeDetailExportDialog() {
      this.localShowDetailExportDialog = false;
      this.resetDefaultView();
    },

    // 导出压缩文件
    exportCompanyDetailData() {
      let params = {
        aaaid: this.$route.query.id3a,
        menuIds: this.selectedColumns.map((item) => item.id),
      };
      exportCompanyDetail(params).then((res) => {
        if (res.status === 200) {
          this.$message({
            type: "success",
          });

          const blob = new Blob([res.data], { type: "application/zip" });
          let fileName = this.localExportFileName;
          fileName += ".zip";

          const href = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = href;
          link.download = fileName;
          link.click();

          // 释放URL对象
          setTimeout(() => {
            URL.revokeObjectURL(href);
          }, 100);
        } else {
          this.$message({
            type: "error",
          });
        }
      });

      this.closeConExportDialog();
    },

    // 点击一级菜单下的子项checkbox
    handleSubItemCheck(obj) {
      this.activeSubItemId = obj.id;

      this.getThreeMenuList(obj.id, obj.isChecked, (exportThreeMenuList) => {
        this.filterList.forEach((item) => {
          item.children.forEach((subItem) => {
            if (subItem.id === obj.id) {
              subItem.children = exportThreeMenuList;
            }
          });
        });
      });
    },

    // 重置一级弹框
    resetDefaultView() {
      // 重置所有选中状态和半选状态
      this.filterList.forEach((item) => {
        item.children.forEach((subItem) => {
          subItem.isChecked = false;
          this.indeterminateSubItems[subItem.id] = false;

          if (subItem.children) {
            subItem.children.forEach((option) => {
              option.isChecked = false;
            });
          }
        });
        this.activeSubItemId = null;
      });

      this.detailCompanyOptions = [];
      this.filterText = "";
      this.activeItemId = null;
      this.activeFrist = [];
      this.threeMenuList = [];
      this.toggleSecMenu(null);
      this.openSecMenus = {};
    },

    // 删除选中的父级
    delFristChosen(item) {
      item.isChecked = false;
      this.indeterminateSubItems[item.id] = false;

      // 取消选中所有子项
      if (item.children) {
        item.children.forEach((option) => {
          option.isChecked = false;
        });
      }

      // 清空当前显示的子选项列表
      this.detailCompanyOptions = [];
    },

    // 打开确认弹窗
    onApplyChanges() {
      this.localConfirmExportDialog = true;
      this.title = `Export (${this.selectedCount} results)`;
    },

    // 关闭确认弹窗
    closeConExportDialog() {
      this.localConfirmExportDialog = false;
      this.resetDefaultView();
      this.localShowDetailExportDialog = false;
    },

    // 取消
    cancelExport() {
      this.closeConExportDialog();
    },

    // 返回
    backExport() {
      this.localConfirmExportDialog = false;
    },
    //获取导出三级菜单列表
    getThreeMenuList(secMenuId, isChecked, callback) {
      let params = {
        aaaid: this.$route.query.id3a,
        menuId: secMenuId,
      };
      getComDetExpThreeMenuList(params).then((res) => {
        if (res.code === 200) {
          const exportThreeMenuList = res.data || [];
          exportThreeMenuList.forEach((item) => {
            if (isChecked) {
              item.isChecked = true;
            }
          });
          this.detailCompanyOptions = JSON.parse(
            JSON.stringify(exportThreeMenuList),
          );
          this.threeMenuList = JSON.parse(JSON.stringify(exportThreeMenuList));
          if (callback) {
            callback(exportThreeMenuList);
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    //获取导出菜单列表
    getExportMenuList() {
      getComDetExpMenuList({
        aaaid: this.$route.query.id3a,
      }).then((res) => {
        if (res.code === 200) {
          const exportMenuList = res.data || [];

          if (exportMenuList.length > 0) {
            exportMenuList.forEach((item) => {
              item.children.forEach((subItem) => {
                subItem.isChecked = false;
                if (subItem.children) {
                  subItem.children.forEach((option) => {
                    option.isChecked = false;

                    if (option.children) {
                      option.children.forEach((subOption) => {
                        subOption.isChecked = false;
                      });
                    }
                  });
                }
              });
            });
            this.filterList = exportMenuList;
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    // 显示二级菜单
    toggleSecMenu(menuId) {
      this.$set(this.openSecMenus, menuId, !this.openSecMenus[menuId]);
    },
  },
};
</script>
<style scoped>
.dialog_cont {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: #1a2332;
}
.input_filter {
  position: relative;
  padding: 10px;
}
.icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
  pointer-events: none;
  z-index: 9;
  font-size: 20px !important;
}
.flex {
  display: flex;
  width: 100%;
  height: 100%;
}
.right,
.left {
  background: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
}
.left {
  width: 650px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
}
.right {
  width: 279px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.menu_box {
  display: flex;
  flex: 1;
  overflow: hidden;
}
.frist_menu_box {
  width: 360px;
  border-right: 1px solid #cccccc;
  overflow-x: hidden;
  overflow-y: auto;
}
.sec_menu_box {
  width: 289px;
  padding: 0 20px;
  overflow-x: hidden;
  overflow-y: auto;
}
.menu_box >>> .el-collapse-item__wrap {
  border-bottom: 0;
}
.menu_box >>> .el-collapse-item__header {
  position: relative;
  font-size: 18px;
  border-bottom: 0;
  background-color: transparent;
  padding: 8px 20px 8px 20px;
  line-height: 24px;
}
.menu_box >>> .el-collapse {
  border-top: 0;
  border-bottom: 0;
}
.new-dialog .frist_sub_li .el-checkbox {
  margin-bottom: 0;
}
.menu_box >>> .el-collapse-item__content {
  padding-bottom: 0;
}
.menu_box >>> .el-collapse-item__header.is-active {
  background-color: #fff;
  color: #1290c9;
}
.frist_sub_li {
  position: relative;
  padding: 5px 20px;
  margin-bottom: 5px;
}
.icon_right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
}
.top_select_title {
  padding: 20px;
  font-weight: bold;
  font-size: 18px;
  color: #1a2332;
  line-height: 30px;
}
.btn_reset_txt >>> span {
  font-family: "Arial Bold";
  font-size: 20px;
  color: #1290c9;
}
::v-deep .btn_reset_txt.is-disabled:hover,
::v-deep .btn_reset_txt.is-disabled {
  background: #fff;
  cursor: not-allowed;
}
::v-deep .btn_reset_txt.is-disabled span {
  color: #999;
}
.fileTips {
  font-size: 20px;
  color: #1a2332;
  line-height: 30px;
  font-style: normal;
  margin: 10px 0 30px;
}
.file_group {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}
.file_label {
  flex: none;
  margin: 14px 10px 10px 0;
  font-size: 20px;
}
.btn_cancel,
.btn_export {
  width: 210px;
  font-size: 20px;
}
.span-width {
  display: inline-block;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.selCol_item {
  position: relative;
  padding: 5px 15px 5px 20px;
  font-size: 18px;
  line-height: 30px;
}
.icon_cuowu {
  position: absolute;
  font-size: 12px !important;
  width: 18px;
  height: 18px;
  line-height: 18px;
  right: 0;
  top: 0;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  background: #ff6a6a;
  transform: translateY(50%);
  margin-top: -3px;
}
.icon_suo {
  width: 16px;
  margin-left: 10px;
}
.input_filter >>> .el-input__inner {
  padding-left: 40px;
}
.file_group >>> .el-input__inner {
  width: 100%;
  font-size: 20px;
}
.sec_menu_box >>> .el-checkbox {
  margin: 10px 0;
}
.sel_frist_name {
  font-family: "Arial Bold";
  position: relative;
  padding-right: 45px;
}
.sel_sec_name {
  margin: 10px 10px;
  display: flex;
}
.frist_sub_li.has_sec >>> .el-checkbox__label {
  color: #1290c9;
}
.sel_ul_Col_box {
  position: relative;
  flex: 1;
  overflow: auto;
}
::v-deep .el-dialog {
  width: 1000px !important;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  margin-top: 10vh !important;
  display: flex;
  flex-direction: column;
  border-radius: 30px;
}
::v-deep .limit_height {
  display: flex;
  flex-direction: column;
  height: 80vh;
  min-height: 346px;
}
::v-deep .el-dialog__body {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}
::v-deep .el-input__inner {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
  color: #1a2332;
  height: 40px;
  font-size: 18px;
}
::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #999;
  opacity: 1;
}
::v-deep .el-input__inner:-moz-placeholder {
  color: #999;
  opacity: 1;
}
::v-deep .el-input__inner::-moz-placeholder {
  color: #999;
  opacity: 1;
}
::v-deep .el-input__inner:-ms-input-placeholder {
  color: #999;
  opacity: 1;
}
.export_dialog >>> .el-button {
  height: 60px;
}
::v-deep .el-checkbox__label {
  vertical-align: middle;
  font-size: 18px;
}
.frist_menu_box >>> .el-checkbox__label {
  max-width: 280px;
}
.sec_menu_box >>> .el-checkbox__label {
  max-width: 220px;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1a2332;
}
::v-deep .el-collapse-item__arrow {
  margin: 0;
  position: absolute;
  right: 10px;
}
.sel_frist_name_box {
  display: flex;
  cursor: pointer;
}
.sel_col_icon_right {
  margin-left: 8px;
  transition: transform 0.3s ease;
}
.sel_col_icon_right.rotate {
  transform: rotate(180deg);
  color: #1290c9;
}
.sel_frist_name_box.open {
  color: #1290c9;
}
.sel_sec_name_box {
  height: 0;
  overflow: hidden;
  opacity: 0;
  transition: height 0.3s ease-out, opacity 0.3s ease-out;
}
.sel_sec_name_box.show {
  height: auto;
  overflow: auto;
  opacity: 1;
  transition: height 0.3s ease-in, opacity 0.3s ease-in;
}
::v-deep .btn_reset_txt + .el-button {
  margin-left: 0;
}
@media (max-width: 1920px) {
  .left {
    width: 487px;
  }
  .frist_menu_box {
    width: 270px;
  }
  .sec_menu_box {
    width: 217px;
    padding: 0 15px;
  }
  .right {
    width: 209px;
  }
  .btn_cancel,
  .btn_export {
    width: 158px;
    font-size: 18px;
  }
  .btn_reset_txt >>> span {
    font-size: 18px;
  }
  .top_select_title {
    padding: 15px;
    line-height: 22px;
    font-size: 16px;
  }

  .icon {
    left: 15px;
  }
  .fileTips {
    line-height: 22px;
    margin: 7px 0 22px;
    font-size: 18px;
  }
  .file_group {
    margin-bottom: 30px;
  }
  .file_label {
    margin: 10px 7px 7px 0;
    font-size: 18px;
  }
  .selCol_item {
    padding: 5px 10px 5px 15px;
    font-size: 16px;
    line-height: 22px;
  }
  .icon_cuowu {
    width: 14px;
    height: 14px;
    line-height: 14px;
  }
  .icon_suo {
    width: 12px;
    margin-left: 7px;
  }
  .file_group >>> .el-input__inner {
    font-size: 18px;
  }
  .sec_menu_box >>> .el-checkbox {
    margin: 7px 0;
  }
  .input_filter >>> .el-input__inner {
    padding-left: 30px;
  }

  .menu_box >>> .el-collapse-item__header {
    font-size: 16px;
    padding: 7px 20px 7px 15px;
    line-height: 18px;
  }
  .frist_sub_li {
    padding: 3px 15px;
    margin-bottom: 3px;
  }
  .iconfont {
    font-size: 14px;
  }
  .sel_sec_name {
    margin: 7px 15px 7px 7px;
  }
  ::v-deep .el-dialog {
    width: 750px !important;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
    border-radius: 22px;
  }
  ::v-deep .el-button {
    height: 45px;
    min-height: 45px;
  }
  ::v-deep .el-input__inner {
    border-radius: 7px;
    font-size: 16px;
    height: 30px;
  }
  ::v-deep .el-checkbox__label {
    font-size: 16px;
  }
  .frist_menu_box >>> .el-checkbox__label {
    max-width: 220px;
  }
  .sec_menu_box >>> .el-checkbox__label {
    max-width: 172px;
  }
}
@media (max-width: 1439px) {
  .left {
    width: 435px;
  }
  .frist_menu_box {
    width: 241px;
  }
  .sec_menu_box {
    width: 194px;
    padding: 0 13px;
  }
  .right {
    width: 186px;
  }
  .btn_cancel,
  .btn_export {
    width: 140px;
    font-size: 16px;
  }
  .btn_reset_txt >>> span {
    font-size: 16px;
  }
  .top_select_title {
    padding: 13px;
    line-height: 20px;
    font-size: 14px;
  }
  .icon {
    left: 13px;
  }
  .fileTips {
    line-height: 20px;
    margin: 6px 0 20px;
    font-size: 16px;
  }
  .file_group {
    margin-bottom: 26px;
  }
  .file_label {
    margin: 9px 6px 6px 0;
    font-size: 16px;
  }
  .selCol_item {
    padding: 5px 9px 5px 12px;
    font-size: 14px;
    line-height: 20px;
  }
  .icon_cuowu {
    width: 12px;
    height: 12px;
    line-height: 12px;
  }
  .icon_suo {
    width: 11px;
    margin-left: 6px;
  }
  .file_group >>> .el-input__inner {
    font-size: 16px;
  }
  .sec_menu_box >>> .el-checkbox {
    margin: 6px 0;
  }
  .input_filter >>> .el-input__inner {
    padding-left: 27px;
  }
  .menu_box >>> .el-collapse-item__header {
    font-size: 14px;
    padding: 6px 20px 6px 12px;
    line-height: 16px;
  }
  .frist_sub_li {
    padding: 3px 13px;
    margin-bottom: 3px;
  }
  .iconfont {
    font-size: 12px;
  }
  .sel_sec_name {
    margin: 6px 15px 6px 6px;
  }
  ::v-deep .el-dialog {
    width: 667px !important;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
    border-radius: 20px;
  }
  ::v-deep .el-button {
    height: 40px;
    min-height: 40px;
  }
  ::v-deep .el-input__inner {
    border-radius: 6px;
    font-size: 14px;
    height: 27px;
  }
  ::v-deep .el-checkbox__label {
    font-size: 14px;
  }
  .frist_menu_box >>> .el-checkbox__label {
    max-width: 180px;
  }
  .sec_menu_box >>> .el-checkbox__label {
    max-width: 155px;
  }
}
</style>
